import axios from '@/utils/request.js'

export const queryCustomerListByStId = params => {
  // 监管企业列表
  return axios.post('/goods/bGlmCustomer/queryCustomerMessListByStId', params)
}
export const queryCustomerInfoMess = params => {
  // 查询
  return axios.post('/goods/bGlmCustomer/queryCustomerInfoMess', params)
}
export const getCompanyList = (params) => {
  // 查询供应商列表
  return axios.post('/goods/gas/company/getCompanyList', params)
}
export const confirmCustomer = params => {
  // 企业确权
  return axios.post('/goods/bGlmCustomer/confirmCustomer', params)
}
export const addManageUser = params => {
  // 新增监管用户
  return axios.post('/goods/bGlmCustomer/addManageUser', params)
}
export const StatisticsCustomerByRegion = params => {
  // 监管用户
  return axios.post('/goods/bGlmCustomer/StatisticsCustomerByRegion', params)
}
export const StatisticsCustomerSupervisionByRegion = params => {
  // 监管用户
  return axios.post('/goods/bGlmCustomer/StatisticsCustomerSupervisionByRegion', params)
}
export const StatisticsCustomerInfoByRegion = params => {
  // 监管用户详细
  return axios.post('/goods/bGlmCustomer/StatisticsCustomerInfoByRegion', params)
}
export const StatisticsSupCustomerInfoByRegion = stId => {
  // 监管用户详细
  return axios.post('/goods/bGlmCustomer/StatisticsSupCustomerInfoByRegion', {
    stId
  })
}
export const StatisticsCylinderByRegion = stId => {
  // 监管钢瓶
  return axios.post('/goods/gas/cylinder/StatisticsCylinderByRegion', {
    stId
  })
}
export const StatisticsCylinderInfoByRegion = stId => {
  // 监管钢瓶详细
  return axios.post('/goods/gas/cylinder/StatisticsCylinderInfoByRegion', {
    stId
  })
}
export const deleteCustomerById = comId => {
  // 删除
  return axios.post('/goods/bGlmCustomer/deleteCustomerById', {
    comId
  })
}
export const exportCustomer = params => {
  // 导出
  return axios.post('/goods/bGlmCustomer/exportCustomer', params)
}
